import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AvatarTooltip from "@Shared/components/general/avatar-tooltip";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ResultSubtitle",
  components: {
    AvatarTooltip
  },
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  computed: {
    email() {
      const {
        email
      } = this.result;
      return email;
    },
    boardName() {
      const {
        boardName
      } = this.result;
      return boardName;
    },
    coApplicants() {
      const {
        coApplicants = []
      } = this.result;
      return coApplicants.length && coApplicants;
    },
    firstThreeCoapplicants() {
      var _context;
      return _sliceInstanceProperty(_context = this.coApplicants).call(_context, 0, 3);
    }
  },
  mounted() {
    this.initTooltips();
  },
  methods: {
    initTooltips() {
      this.$nextTick(() => {
        var _context2;
        const tooltips = _findInstanceProperty(_context2 = $(this.$refs.titleWrapper)).call(_context2, "[data-toggle='tooltip']");
        tooltips.tooltip({
          placement: "right"
        });
      });
    }
  }
});